let index_tab_num = 0;
$('.header .toggle').on('click', function () {
    $(this).toggleClass('active');
    $('.header ul').toggleClass('active');
});
let flag;
var _token;
var _e_id;
let seLectedTags = [];
function changeRadio(className) {
    var radioButton = document.getElementById(className);
    var radioLabel = document.querySelector(`label[for="${className}"]`);
    radioLabel.addEventListener('click', function () {
        var isChecked = radioButton.checked;
        if (!isChecked) {
            radioButton.checked = true;
        }
        return isChecked;
    })
};

if ($('.radioItem').length) {
    $('.radioItem').each((i, el) => {
        $(el).on('click', function () {

            changeRadio(el.querySelector('input[type="radio"]').id);
            genDerId = i;
        })
    })
}
// $('.visibilityRadio').each((i,el) => {
//     $(el).on('click',function() {
//         changeRadio(el.querySelector('input[type="radio"]').id);
//         visiBilityId = i;
//     })
// })
function handleProfile(e) {
    e.stopPropagation();
    redirectToUrl(`${lang_path}/account/profile/`);
}
function handleInfo(e) {
    e.stopPropagation();
    $('#loginMask').removeClass('isshowme').addClass('ishideme');
    $('.edit_profile').addClass('active');
    $('.profile_mask').addClass('active');
    $('body').addClass('hide_pro');
    $('.ivu-layout-content').addClass('hide_pro');
    manage('Profile_Edit_Click', '');
    defaultDisplayOfScrollbar();
}
function handleLogout(e) {
    e && e.stopPropagation();
    $('#loginMask').removeClass('isshowme').addClass('ishideme');
    if ($(this).data('clicked')) {
        return;
    }
    $(this).data('clicked', true);
    $('.loadingMask').addClass('show');
    getAjax('/api/account/logout', { e_id: _e_id }).then(res => {
        if (res.code == 0) {
            handleLoggedOutState();
        } else if (res.code == 20005) {
            handleLoggedOutState();
        } else {
            $(this).data('clicked', false);
        }
    });
};
function toggleLoginMask(userInfoData) {
    if (!userInfoData) return;
    // 检查 #loginMask 是否已经存在，避免重复添加

    // 切换个人信息弹窗的显示状态
    if ($('#loginMask').hasClass('isshowme')) {
        $('#loginMask').removeClass('isshowme').addClass('ishideme');
    } else {
        $('#loginMask').removeClass('ishideme').addClass('isshowme');
        $('.menuIcon').removeClass('icon-menu_close').addClass('icon-menu');
        $('.drawer-main-mask').hide();
    }
}
function login_toggle(e) {
    checkLoginStatus();
    if (!window.isLoggedIn) {
        manage('Login_Page_View');
        redirectToUrl(`${lang_path}/account/login/`);
    } else {
        e.stopPropagation();
        toggleLoginMask(JSON.parse(cookie.getcookie('userInfoData')));
    }
}
$(document).ready(function () {
    if ($('.loadingMask').length == 0) {
        $('.main_section').append('<div class="loadingMask"><div class="loadanimation" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%,-50%);z-index: 100;"></div></div>')
    }
    if (cookie.getcookie('Hbanner') != '1') {
        $('.banner').show();
    }
    // 初始化前端登录状态
    checkLoginStatus();
    _token = JSON.parse(cookie.getcookie('user')) ? JSON.parse(cookie.getcookie('user')).token : null;
    _e_id = JSON.parse(cookie.getcookie('user')) ? JSON.parse(cookie.getcookie('user')).e_id : null;
    function checkLoginAndRedirect(url, operation) {
        checkLoginStatus(); // 每次点击按钮时先检查登录状态
        if (!window.isLoggedIn) {
            $('.main_section').append(`<div class="loginRequiredMask">
                <div class="loginRequired">
                    <img src="/images/index/logo_pad.svg" class="logo" alt="Logo Pad"/>
                    <div class="title">${i18n[lang].public_Login_Required}</div>
                    <div class="desc">${i18n[lang].public_In_order}</div>
                    <div class="button">${i18n[lang].log_in}</div>
                </div>
            </div>`)
            manage('Popup_Login_View');
        } else {
            location.href = url;
        }
        $('.loginRequiredMask').on('click', function () {

            $('.main_section .loginRequiredMask').remove();
        })
        $('.loginRequired').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
        })
        $('.loginRequiredMask .button').on('click', function (e) {
            manage('Popup_Login_Click');
            location.href = `${lang_path}/account/login/`
        })
    };
    $('.createMenu').on('click', function (e) {
        e.preventDefault();
        checkLoginAndRedirect(`${lang_path}/character/create/`, 'Sidebar_Create_Click');
    })
    $('.profileMenu').on('click', function (e) {
        e.preventDefault();
        checkLoginAndRedirect(`${lang_path}/account/profile/`, 'Sidebar_Profile_Click');
    })
    // 绑定登录按钮事件
    $('.loginButton').on('click', login_toggle);
    if (_token) {
        try { login_handle(_token); } catch (e) { }
    } else if (cookie.getcookie('user_google') || cookie.getcookie('google_key')) {
        // 走google登陆
    } else {
        $('.loginButton').empty();
        $('#loginMask').removeClass('isshowme').addClass('ishideme')
        $('.loginButton').append(`<i class="ivu-icon iconfont icon-user userIcon"></i><span class="signIn">${i18n[lang].log_in}</span>`);
        nologin_handle();
    }
    // 获取当前路径
    var currentPath = window.location.pathname;

    // 定义路径模式的正则表达式
    var pattern = /^\/character\/\d+$/;
    if (pattern.test(currentPath)) {
        var windowWidth = $(window).width();
        if (windowWidth > 768) {
            $('.drawer-main-mask').hide();
            $('.ivu-layout-sider').hide();
        } else {
            $('.drawer-main-mask').show();
            $('.ivu-layout-sider').show();
        }
    }
    defaultDisplayOfScrollbar();
    //notification 相关
    let notification_type = 2;
    let notification_pageNum = 1;
    let notification_isLoading = false;
    let _notic = 1;
    let system_notification = 0;
    let max_number = 10000;
    $('.notiMenu').on('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
        checkLoginStatus();
        if (!window.isLoggedIn) {
            addNoLogin();
        } else {if ($('.ivu-layout-sider').hasClass('ivu-layout-has-sider')) {
            $('.ivu-layout-sider').removeClass('ivu-layout-has-sider').removeClass('layout-app');
            $('.notification_zoon').removeClass('active');
            $('.notification_mask').removeClass('active');
            if (_notic == 0) {
                getAjax(_url.updateStatus).then(res => {
                    if (res.code == 200) {
                        _notic = 1;
                        $('.icon-menu_noti').removeClass('active');
                        $('.left_tab_item').removeClass('active');
                        $('.notification_tab_index').find('span').removeClass('active');
                        getride_dot()
                    } else if (res.code == 9001) {
                        error(i18n[lang].public_Network_error);
                    } else if (res.code == 204) {
                        return false;
                    } else if (res.code == 500) {
                        error(i18n[lang].public_Network_error);
                    }
                });
            };
        } else {
            $('.ivu-layout-sider').addClass('ivu-layout-has-sider').addClass('layout-app');
            $('.notification_zoon').addClass('active');
            $('.notification_mask').addClass('active');
        }
        }
    });
    $('.notification_close,.notification_mask').on('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
        $('.notification_zoon').removeClass('active');
        $('.notification_mask').removeClass('active');
        $('.ivu-layout-sider').removeClass('ivu-layout-has-sider').removeClass('layout-app');
        if (_notic == 0) {
            getAjax(_url.updateStatus).then(res => {
                if (res.code == 200) {
                    _notic = 1;
                    $('.icon-menu_noti').removeClass('active');
                    $('.left_tab_item').removeClass('active');
                    $('.notification_tab_index').find('span').removeClass('active');
                    getride_dot()
                } else if (res.code == 9001) {
                    error(i18n[lang].public_Network_error);
                } else if (res.code == 204) {
                    return false;
                } else if (res.code == 500) {
                    error(i18n[lang].public_Network_error);
                }
            });
        }
    });
    $('.notification_zoon').on('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
    });
    function notification_loadMore() {
        if (notification_isLoading) return;
        notification_isLoading = true;
        $('.notification_item_zoon').append(`<img src="/images/index/loading.svg" alt="loading" class="notification_loading_s" width="48" height="48">`);
        _notification(notification_pageNum, Number(cookie.getcookie('notification_type')));
    }
    $('.notification_tab_index').on('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
        $(this).addClass('active').siblings().removeClass('active');
        try { $('.notification_item_zoon').empty(); } catch (e) { };
        try { $('.notification_img').remove(); } catch (e) { };
        try { $('.notification_tips').remove(); } catch (e) { };
        system_notification = $(this).index();
        notification_pageNum = 1;
        _notification(notification_pageNum, notification_type + $(this).index());
        cookie.setcookie('notification_type', notification_type + $(this).index(), 90);
    });
    function _notification(a, b) {
        $('.notification_item_zoon').append(`<img src="/images/index/loading.svg" alt="loading" class="notification_loading" width="48" height="48">`);
        getAjax(_url.getNftLists, { pageNum: a, type: b }).then(res => {
            $('.notification_loading').remove();
            try { $('.notification_loading_s').remove(); } catch (e) { };
            if (res.code == 200) {
                $('.notification_item_zoon').removeClass('column');
                if (res.data.list.length > 0) {
                    notification_pageNum++;
                    res.data.list.forEach((e, i) => {
                        var _clssss;
                        e.status == 0 ? _clssss = 'active' : _clssss = '';
                        if (e.notification_type == 0 && system_notification == 0) {
                            $('.notification_item_zoon').append(`
                                <${e.action_type == 7 ? 'div' : 'a'} href="${e.examine_type == 3 ? lang_path+'/bonus/' :  e.action_type == 8 ? lang_path+'/account/profile/' + e.openid : e.action_type == 9 ? lang_path+'/account/profile/' : e.action_type == 10 ? lang_path+'/chat/' + e.roleid : lang_path+'/character/' + e.roleid}" attr-roleid="${e.roleid}" class="notification_tab_item flex_box notification_tab_item${e.roleid} notification_tab_item${e.action_type}" notification_tab_item${e.uid}" attr-action_type="${e.action_type}">
                                <div class="left_tab_item ${_clssss}"><img src="${e.action_type == 10 ?e.robot.avatar_url:'/images/index/logo_pad.svg'}" alt="user_img" width="48" height="48" class="user_img"></div>
                                    <div class="tab_item_info ${e.action_type != 7 && e.action_type != 8 ? 'system' : ''}">
                                        <p class="item_name ${e.action_type == 10 ?'flex_box':''}">${e.action_type == 10 ? i18n[lang].public_New_Character+': '+e.robot.name : 'HeyReal'}</p>
                                        <p class="item_info">${e.content}${e.action_type != 7 && e.action_type != 8  && e.action_type != 10 ? '<span>' + e.createtime + '</span>' : ''}</p>
                                    </div>
                                    ${e.action_type == 10 ? '<div class="item_status"><p class="status_btn status_btn' + e.roleid + '" attr-href="/chat/' + e.roleid +'">'+i18n[lang].public_take+'</p><p class="status_time">' + e.createtime + '</p></div>' : e.action_type == 7 ? '<div class="item_status"><p class="status_btn status_btn' + e.roleid + '" attr-href="https://discord.gg/aXvBRYtP2A">'+i18n[lang].public_Explore_Now+'</p><p class="status_time">' + e.createtime + '</p></div>' : e.action_type == 8 ? '<div class="item_status"><p class="status_btn status_btn' + e.roleid + '" attr-href="'+lang_path+'/account/profile/">'+i18n[lang].public_Check_Now+'</p><p class="status_time">' + e.createtime + '</p></div>': ''}
                                </${e.action_type == 7 ? 'div' : 'a'}>
                            `);
                            $(`.status_btn${e.roleid}`).on('click', function (e) {
                                e.stopPropagation();
                                e.preventDefault();
                                var newWindow;
                                newWindow = window.open('about:blank', '');
                                newWindow.location.href = $(this).attr('attr-href');
                            });
                            $(`a.notification_tab_item${e.roleid}`).on('click', function (e) {
                                e.stopPropagation();
                                e.preventDefault();
                                location.href = $(this).attr('href');
                            });
                            _notic = _notic * e.status;
                        }
                        else if (e.notification_type == 1 && system_notification == 1) {
                            var img = new Image();
                            img.src = e.users.avatar_url;
                            img.onload = function () {
                            };
                            $('.notification_item_zoon').append(`
                                <${e.action_type == 2 ? 'div' : 'a href="'+lang_path+'/character/' + e.roleid + '"'} id="${e.roleid}" class="notification_tab_item flex_box notification_tab_item${e.roleid} notification_tab_item${e.action_type} notification_tab_item${e.uid}" attr-action_type="${e.action_type}">
                                <div class="left_tab_item ${_clssss}"><img src="${e.users.avatar_url}" alt="user_img" width="48" height="48" attr-href="${lang_path}/account/profile/${e.users.openid}" class="user_img"></div>
                                    <div class="tab_item_info">
                                        <p class="item_name" attr-href="${lang_path}/account/profile/${e.users.openid}">${e.users.nickname}</p>
                                        <p class="item_info">${e.content}</p>
                                    </div>
                                    <div class="item_status">
                                        ${e.action_type == 3 || e.action_type == 2 ?`<p attr-roleid="${e.roleid}" attr-openid="${e.users.openid}" attr-other_id="${e.other_id ? e.other_id : ''}" class="status_btn status_btn${e.users.openid} status_btn${e.users.openid}${e.roleid}${e.action_type} ${e.action_type == 3 ? i18n[lang].public_Review : i18n[lang].public_Follow} ${e.follow_status == 1 ? 'fit' : ''}" ${ e.action_type == 2 ? 'attr-follow_status="' + (e.follow_status + 1) % 2 + '"' : ''}>${e.action_type == 3 ? i18n[lang].public_Review : (e.action_type == 2) && e.follow_status == 1 ? i18n[lang].public_Following : i18n[lang].public_Follow}</p>`:''}
                                        <p class="status_time">${e.createtime}</p>
                                    </div>
                                </${e.action_type == 2 ? 'div' : 'a'}>
                            `);
                            _notic = _notic * e.status;
                            //${e.action_type==3?i18n[lang].public_Review:(e.action_type==0||e.action_type==1||e.action_type==2)&&e.follow_status==1?i18n[lang].public_Following:i18n[lang].public_Follow}
                            $(`.notification_tab_item${e.roleid} .item_name,.notification_tab_item${e.roleid} .user_img`).on('click', function (e) {
                                e.stopPropagation();
                                e.preventDefault();
                                window.location.href = $(this).attr('attr-href');
                            });
                            $(`.status_btn${e.users.openid}${e.roleid}${e.action_type}.Follow`).on('click', function (e) {
                                e.stopPropagation();
                                e.preventDefault();
                                toggleFollow(Number($(this).attr('attr-openid')), Number($(this).attr('attr-follow_status')));
                            });
                            // if($(window).width()>1280){
                            //     $(`.notification_tab_item${e.roleid} .status_btn.fit`).hover(function(){
                            //         $(this).html('UnFollow');
                            //     },function(){
                            //         $(this).html(i18n[lang].public_Following);
                            //     })
                            // };
                            $(`.notification_tab_item${e.roleid} .status_btn.Review`).on('click', function (e) {
                                e.stopPropagation();
                                e.preventDefault();
                                window.location.href = lang_path+'/character/' + $(this).attr('attr-roleid') + '?#' + $(this).attr('attr-other_id');
                            });
                        };
                        $(`a.notification_tab_item${e.roleid}`).on('click', function (e) {
                            e.stopPropagation();
                            e.preventDefault();
                            window.location.href = $(this).attr('href');
                        })
                    });
                    if (_notic == 0) {
                        $('.icon-menu_noti').addClass('active');
                        $('.navigation .leftNavigation .menuIcon').addClass('active');
                    }
                } else {
                    $('.notification_item_zoon').addClass('column');
                    $('.notification_item_zoon').append(`
                        <img class="notification_img" src="/images/index/report-success.svg" width="48" height="48" />
                        <p class="notification_tips">${i18n[lang].public_notifications}</p>
                    `);
                };
                setTimeout(function () {
                    if (notification_pageNum >= res.data.last_page) {
                        notification_unbindScroll();
                        notification_isLoading = true;
                    } else {
                        notification_isLoading = false;
                        notification_bindScroll();
                    }
                }, 500);
            } else if (res.code == 9001) {
                error(i18n[lang].public_Network_error);
            } else if (res.code == 204) {
                $('.notification_item_zoon').addClass('column');
                    $('.notification_item_zoon').append(`
                        <img class="notification_img" src="/images/index/report-success.svg" width="48" height="48" />
                        <p class="notification_tips">${i18n[lang].public_notifications}</p>
                    `);
            } else if (res.code == 500) {
                error(i18n[lang].public_Network_error);
            }
        });
    };
    setTimeout(function () {
        if(_token){
            _notification (1, 2);
            getAjax(_url.getRedDot, {
            }).then(res => {
                if (res.code == 200) {
                    $('.missionContent .social_num').text(res.data.social_num);
                    if (res.data && res.data.message_red == 1) {
                        _notic=0;
                        $('.icon-menu_noti').addClass('active');
                        $('.navigation .leftNavigation .menuIcon').addClass('active');
                        if(res.data.notification_type == 0){
                            $('.notification_tab_index').eq(0).find('span').addClass('active');
                        } else if(res.data.notification_type == 1){
                            $('.notification_tab_index').eq(1).find('span').addClass('active');
                        } else if(res.data.notification_type == 2){
                            $('.notification_tab_index').find('span').addClass('active');
                        }
                    }
                    try{if(res.data.Mission_red == 1)$('.mission span').addClass('active');
                    if(res.data.Achievement_red == 1)$('.achievement span').addClass('active');}catch(e){}
                    if(res.data.social_num==6&&$('.SocialContent').length){$('.SocialContent').addClass('mission_toggled').addClass('fit')}
                }
            });
        };
    }, 1000);
    // 解除绑定 scroll 事件
    function notification_unbindScroll() {
        $('.notification_item_zoon').off('scroll', notification_handleScroll);
    }

    // 重新绑定 scroll 事件
    function notification_bindScroll() {
        $('.notification_item_zoon').on('scroll', notification_handleScroll);
    }

    // 定义 scroll 事件处理函数
    function notification_handleScroll() {
        const scrollTop = $(this).scrollTop();
        const scrollHeight = $(this).prop('scrollHeight');
        const clientHeight = $(this).height();
        if (scrollTop + clientHeight >= scrollHeight - 500) {
            notification_loadMore();
        }
    }
    notification_bindScroll();
    function getride_dot() {
        getAjax(_url.getRedDot, {
        }).then(res => {
            if (res.code == 200) {
                if (res.data && res.data.message_red != 1 && res.data.red_dot != 1) {
                    $('.icon-menu_noti').removeClass('active');
                    $('.left_tab_item').removeClass('active');
                    $('.navigation .leftNavigation .menuIcon').removeClass('active');
                    $('.notification_tab_index').find('span').removeClass('active');
                }
            }
        })
    };
    setTimeout(function () {
        checkLoginStatus();
        try {
            if (window.isLoggedIn && io) {
                const userId = "message" + JSON.parse(cookie.getcookie('userInfoData')).uid;
                var ws_link;
                if (location.hostname == 'localhost-www.heyreal.ai') {
                    ws_link = 'http://sandbox.heyreal.socket:3002/'
                } else if (location.hostname == 'sandbox.heyreal.ai') {
                    ws_link = 'http://sandbox.heyreal.socket:3002/'
                } else if (location.hostname == 'pre.heyreal.ai') {
                    ws_link = 'https://wss.heyreal.ai/'
                } else {
                    ws_link = 'https://wss.heyreal.ai/'
                };
                const socket = io(ws_link);//http://localhost:3000
                socket.on('connect', () => {
                    socket.emit('register', userId);// 注册用户 ID
                });

                socket.on('message', (msg) => {
                    handleInfo_notification(msg)
                });

                socket.on('disconnect', () => {
                });
            }
        } catch (e) { };
    }, 7000);
    checkLoginStatus();
    function handleInfo_notification(msg) {
        max_number--;
        if($('.notification_item_zoon').find('.notification_img').length){
            $('.notification_item_zoon').empty();
        };
        msg.forEach((e, i) => {
            if ($(`.notification_tab_item${e.roleid}.notification_tab_item${e.action_type}.notification_tab_item${e.uid}`).length > 0 && Number($(`.notification_tab_item${e.roleid}.notification_tab_item${e.action_type}.notification_tab_item${e.uid}`).attr('attr-action_type')) == e.action_type) {
                $(`.notification_tab_item${e.roleid}.notification_tab_item${e.action_type}.notification_tab_item${e.uid}`).find('.left_tab_item').addClass('active');
                $(`.notification_tab_item${e.roleid}.notification_tab_item${e.action_type}.notification_tab_item${e.uid}`).css({'order': max_number});
                if(e.notification_type==0){
                    $('.notification_tab_index').eq(0).find('span').addClass('active');
                    $(`.notification_tab_item${e.roleid}.notification_tab_item${e.action_type}.notification_tab_item${e.uid}`).find('img').attr('src',e.action_type==7?e.users.avatar_url:'/images/index/icon-login.svg');
                    $(`.notification_tab_item${e.roleid}.notification_tab_item${e.action_type}.notification_tab_item${e.uid}`).find('.status_btn').html(e.action_type==0?'Like':e.action_type==1?'Collect':e.action_type==2?i18n[lang].public_Follow:e.action_type==3?i18n[lang].public_Review:e.action_type==4?i18n[lang].public_Follow:e.action_type==5?i18n[lang].public_Follow:i18n[lang].public_Follow);
                    $(`.notification_tab_item${e.roleid}.notification_tab_item${e.action_type}.notification_tab_item${e.uid}`).find('.item_info').html(e.content+`${e.action_type != 7 && e.action_type != 8?'<span>'+e.createtime+'</span>':''}`);
                    $(`.notification_tab_item${e.roleid}.notification_tab_item${e.action_type}.notification_tab_item${e.uid}`).css('order',max_number);
                }
                else if(e.notification_type==1){
                    $('.notification_tab_index').eq(1).find('span').addClass('active');
                    $(`.notification_tab_item${e.roleid}.notification_tab_item${e.action_type}.notification_tab_item${e.uid}`).find('img').attr('src',e.users.avatar_url?e.users.avatar_url:'/images/index/icon-login.svg');
                    $(`.notification_tab_item${e.roleid}.notification_tab_item${e.action_type}.notification_tab_item${e.uid}`).find('.item_name').html(e.users.nickname);
                    $(`.notification_tab_item${e.roleid}.notification_tab_item${e.action_type}.notification_tab_item${e.uid}`).find('.item_info').html(e.content);
                    $(`.notification_tab_item${e.roleid}.notification_tab_item${e.action_type}.notification_tab_item${e.uid}`).find('.status_time').html(e.createtime);
                    $(`.notification_tab_item${e.roleid}.notification_tab_item${e.action_type}.notification_tab_item${e.uid}`).css('order',max_number);
                }
            } else if (e.notification_type == 0 && system_notification == 0) {
                var _clssss;
                e.status == 0 ? _clssss = 'active' : _clssss = '';
                $('.notification_item_zoon').prepend(`
                    <${e.action_type == 7 ? 'div' : 'a'} href="${e.examine_type == 3 ? lang_path+'/bonus/' :  e.action_type == 8 ? lang_path+'/account/profile/' + e.openid : e.action_type == 9 ? lang_path+'/account/profile/' : e.action_type == 10 ? lang_path+'/chat/' + e.roleid : lang_path+'/character/' + e.roleid}" attr-roleid="${e.roleid}" class="notification_tab_item${e.roleid} notification_tab_item${e.action_type} notification_tab_item${e.uid} notification_tab_item flex_box" attr-action_type="${e.action_type}" style="order:${max_number}">
                    <div class="left_tab_item active"><img src="${e.action_type == 10 ?e.robot.avatar_url:'/images/index/logo_pad.svg'}" alt="user_img" width="48" height="48" class="user_img"></div>
                        <div class="tab_item_info ${e.action_type != 7 && e.action_type != 8 ? 'system' : ''}">
                        <div class="tab_item_info ${e.action_type != 7 && e.action_type != 8 ? 'system' : ''}">
                            <p class="item_name ${e.action_type == 10 ?'flex_box':''}">${e.action_type == 10 ? i18n[lang].public_New_Character+': '+e.robot.name : 'HeyReal'}</p>
                            <p class="item_info">${e.content}${e.action_type != 7 && e.action_type != 8  && e.action_type != 10 ? '<span>' + e.createtime + '</span>' : ''}</p>
                        </div>
                        ${e.action_type == 10 ? '<div class="item_status"><p class="status_btn status_btn' + e.roleid + '" attr-href="/chat/' + e.roleid +'">'+i18n[lang].public_take+'</p><p class="status_time">' + e.createtime + '</p></div>' : e.action_type == 7 ? '<div class="item_status"><p class="status_btn status_btn' + e.roleid + '" attr-href="https://discord.gg/aXvBRYtP2A">'+i18n[lang].public_Explore_Now+'</p><p class="status_time">' + e.createtime + '</p></div>' : e.action_type == 8 ? '<div class="item_status"><p class="status_btn status_btn' + e.roleid + '" attr-href="'+lang_path+'/account/profile/">'+i18n[lang].public_Check_Now+'</p><p class="status_time">' + e.createtime + '</p></div>': ''}
                    </${e.action_type == 7 ? 'div' : 'a'}>
                `);
                $(`.status_btn${e.roleid}`).on('click', function (e) {
                    e.stopPropagation();
                    e.preventDefault();
                    var newWindow;
                    newWindow = window.open('about:blank', '');
                    newWindow.location.href = $(this).attr('attr-href');
                });
                $(`a.notification_tab_item${e.roleid}`).on('click', function (e) {
                    e.stopPropagation();
                    e.preventDefault();
                    location.href = $(this).attr('href');
                });
            }
            else if (e.notification_type == 1 && system_notification == 1) {
                var img = new Image();
                img.src = e.users.avatar_url;
                img.onload = function () {
                };
                $('.notification_item_zoon').prepend(`
                    <${e.action_type == 2 ? 'div' : 'a href="'+lang_path+'/character/' + e.roleid + '"'} id="${e.roleid}" class="notification_tab_item${e.roleid} notification_tab_item${e.action_type} notification_tab_item${e.uid} notification_tab_item flex_box" attr-action_type="${e.action_type}" style="order:${max_number}">
                    <div class="left_tab_item active"><img src="${e.users.avatar_url}" alt="user_img" width="48" height="48" attr-href="${lang_path}/account/profile/${e.users.openid}" class="user_img"></div>
                        <div class="tab_item_info">
                            <p class="item_name" attr-href="${lang_path}/account/profile/${e.users.openid}">${e.users.nickname}</p>
                            <p class="item_info">${e.content}</p>
                        </div>
                        <div class="item_status">
                            ${e.action_type == 3 || e.action_type == 2 ?`<p attr-roleid="${e.roleid}" attr-openid="${e.users.openid}" attr-other_id="${e.other_id ? e.other_id : ''}" class="status_btn status_btn${e.users.openid} status_btn${e.users.openid}${e.roleid}${e.action_type} ${e.action_type == 3 ? i18n[lang].public_Review : i18n[lang].public_Follow} ${e.follow_status == 1 ? 'fit' : ''}" ${ e.action_type == 2 ? 'attr-follow_status="' + (e.follow_status + 1) % 2 + '"' : ''}>${e.action_type == 3 ? i18n[lang].public_Review : (e.action_type == 2) && e.follow_status == 1 ? i18n[lang].public_Following : i18n[lang].public_Follow}</p>`:''}
                            <p class="status_time">${e.createtime}</p>
                        </div>
                    </${e.action_type == 2 ? 'div' : 'a'}>
                `);
                $(`.notification_tab_item${e.roleid} .item_name,.notification_tab_item${e.roleid} .user_img`).on('click', function (e) {
                    e.stopPropagation();
                    e.preventDefault();
                    window.location.href = $(this).attr('attr-href');
                });
                $(`.status_btn${e.users.openid}${e.roleid}${e.action_type}.Follow`).on('click', function (e) {
                    e.stopPropagation();
                    e.preventDefault();
                    toggleFollow(Number($(this).attr('attr-openid')), Number($(this).attr('attr-follow_status')));
                });
                // if($(window).width()>1280){
                //     $(`.notification_tab_item${e.roleid} .status_btn.fit`).hover(function(){
                //         $(this).html('UnFollow');
                //     },function(){
                //         $(this).html(i18n[lang].public_Following);
                //     })
                // };
                $(`.notification_tab_item${e.roleid} .status_btn.Review`).on('click', function (e) {
                    e.stopPropagation();
                    e.preventDefault();
                    window.location.href = lang_path+'/character/' + $(this).attr('attr-roleid') + '?#' + $(this).attr('attr-other_id');
                });
                $(`a.notification_tab_item${e.roleid}`).on('click', function (e) {
                    e.stopPropagation();
                    e.preventDefault();
                    window.location.href = $(this).attr('href');
                })
            }
            _notic = _notic * e.status;
        });
        $('.icon-menu_noti').addClass('active');
        $('.navigation .leftNavigation .menuIcon').addClass('active');
    };
});
// 消息关注
function toggleFollow(openid, status) {
    getAjax(_url.followUpdate, {
        "uid": openid,
        "status": status
    }).then(res => {
        if (res.code == 200) {
            if (status == 0) {
                $(`.status_btn${openid}.Follow`).html(i18n[lang].public_Follow).attr('attr-follow_status', 1).removeClass('fit');
                success(i18n[lang].public_Successfully_Unfollow);
            } else {
                $(`.status_btn${openid}.Follow`).html(i18n[lang].public_Following).attr('attr-follow_status', 0).addClass('fit');
                success(i18n[lang].public_Successfully_Follow);
            };
            getAjax(_url.getUserInfo, { e_id: _e_id }).then(response => {
                if (response.code == 8001) {
                    handleLogout();
                } else if (response.code != 200) {
                    return;
                };
                response.data.fans_num ? iD('profile_followers').innerHTML = autoNumberTransform(response.data.fans_num) : null;
                response.data.follow_num ? iD('profile_following').innerHTML = autoNumberTransform(response.data.follow_num) : null;
            });
        } else {
            if (status == 0) {
                $(`.status_btn${openid}.Follow`).html(i18n[lang].public_Following).attr('attr-follow_status', 0).addClass('fit');
                error(i18n[lang].public_Failed_Unlike);
            } else {
                $(`.status_btn${openid}.Follow`).html(i18n[lang].public_Follow).attr('attr-follow_status', 1).removeClass('fit');
                error(i18n[lang].public_Failed_Followed);
            }
        }
    }).catch(res => {
        if (status == 0) {
            $(`.status_btn${openid}`).html(i18n[lang].public_Following).attr('attr-follow_status', 0).addClass('fit');
            error(i18n[lang].public_Failed_Unlike);
        } else {
            $(`.status_btn${openid}`).html(i18n[lang].public_Follow).attr('attr-follow_status', 1).removeClass('fit');
            error(i18n[lang].public_Failed_Followed);
        }
    });
};
function nologin_handle() {
    if ($('.missionContent').length) {
        batchAdd('.missionContent .signIn')
        batchAdd('.missionContent .create')
        batchAdd('.missionContent .exchange')
        batchAdd('.missionContent .wordSubmit')
        batchAdd('.missionContent .videoSubmit')
        batchAdd('.missionContent .follow')
    }
}
function batchAdd(el) {
    $(el).click(function () {
        addNoLogin();
        return false
    })
}
function addNoLogin() {
    $('.main_section').append(`<div class="loginRequiredMask">
        <div class="loginRequired">
            <img src="/images/index/logo_pad.svg" class="logo" alt="Logo Pad"/>
            <div class="title">${i18n[lang].public_Login_Required}</div>
            <div class="desc">${i18n[lang].public_In_order}</div>
            <div class="button">${i18n[lang].log_in}</div>
        </div>
    </div>`)
    $('.loginRequiredMask').on('click', function () {
        $('.main_section .loginRequiredMask').remove();
    })
    $('.loginRequired').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
    })
    $('.loginRequiredMask .button').on('click', function (e) {
        manage('Popup_Login_Click');
        location.href = `${lang_path}/account/login/`
    })
    manage('Popup_Login_View');
}

/**
 * 滚动条默认显示逻辑
 */
function defaultDisplayOfScrollbar() {
    let isScrolling;

    $('.scrollLogic').on('scroll', function () {
        const $this = $(this);
        $this.addClass('scroll-active');

        clearTimeout(isScrolling);
        isScrolling = setTimeout(function () {
            $this.removeClass('scroll-active');
        }, 1000); // 在滚动停止后 1 秒隐藏滚动条
    });

    $('.scrollLogic').on('mouseleave', function () {
        const $this = $(this);
        if (!$this.scrollTop() && !$this.scrollLeft()) {
            $this.removeClass('scroll-active');
        }
    });

    // 在触摸开始时显示滚动条
    $('.scrollLogic').on('touchstart', function () {
        $(this).addClass('scroll-active');
    });

    // 在触摸结束后隐藏滚动条
    $('.scrollLogic').on('touchend', function () {
        const $this = $(this);
        setTimeout(function () {
            $this.removeClass('scroll-active');
        }, 1000);
    });
}

$('.banner .closeBtn').click(function () {
    cookie.setcookie('Hbanner', 1)
    $('.banner').hide();
})

//
$('.logo').on('click', function () {
    redirectToUrl(`${lang_path}/`)
});
// 封装跳转URL的方法
function redirectToUrl(url) {
    window.location.href = url;
};

$('.menuIcon').click(function () {
    var drawerDisplay = $('.drawer-main-mask').css('display');

    if (drawerDisplay === 'block') {
        $('.menuIcon').removeClass('icon-menu_close').addClass('icon-menu');
        $('.drawer-main-mask').hide();
        $('html,body').removeClass('hide');
    } else {
        $('.menuIcon').removeClass('icon-menu').addClass('icon-menu_close');
        $('.drawer-main-mask').show();
        $('html,body').addClass('hide');
    }
    $(document).off('click', '.menuIcon');
});
let initialWidth = window.innerWidth;
$(window).on('resize', function () {
    // 获取当前窗口宽度和高度
    var width = $(window).width();
    var height = $(window).height();
    if (width!== initialWidth) {
    if (width > 768) {
        $('.drawer-main-mask').hide();
    } else if(width <= 768) {
        if ($('.icon-menu_close').length != 0) {
            $('.drawer-main-mask').show();
        }
    }
    if (width > 430) {
        $('.classification .left').css('height', '4.5rem');
    } else if(width <= 430) {
        $('.classification .left').css('height', '3.5rem');
    }}
    var $menu1 = $('.menu_more-content');
    if ($menu1.length > 0) {
        $menu1.css('bottom', $(window).height() - $(".moreMenuButton").eq(1).offset().top + 10);
    }
})
document.addEventListener('gesturestart', function (e) {
    e.preventDefault();
});
document.addEventListener('gesturechange', function (e) {
    e.preventDefault();
});
document.addEventListener('gestureend', function (e) {
    e.preventDefault();
});
function adjustHeight() {
    document.documentElement.style.setProperty('--viewport-height', `${$(window).height()}px`);
    document.documentElement.style.setProperty('--viewport-width', `${$(window).width()}px`);
}

// Initial adjustment
adjustHeight();

// Adjust on resize
window.addEventListener('resize', adjustHeight);

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.default-avatar').forEach(function (img) {
        var avatarUrl = img.getAttribute('data-avatar');
        if (avatarUrl && (avatarUrl !== '/images/index/defaultAvatar.svg'||avatarUrl !== '/images/dark-theme/index/defaultAvatar.svg')) {
            var preloader = new Image();
            preloader.onload = function () {
                img.src = avatarUrl;
            };
            preloader.onerror = function () {
                img.src = '/images/index/defaultAvatar.svg';
            };
            preloader.src = avatarUrl;
        }
    });
});

// 点击事件监听逻辑
document.querySelectorAll('.homeItemInPHP').forEach(function (item) {
    item.addEventListener('click', function (e) {
        e.preventDefault();
        var roleid = this.getAttribute('data-roleid');
        var name = this.getAttribute('data-name');
        var tagsid = this.getAttribute('data-tags');
        var greetings = this.getAttribute('data-greetings');
        localStorage.setItem('robotInfo', JSON.stringify({ name: name, tags: JSON.parse(tagsid), greetings: greetings }))
        // 在这里添加你希望触发的逻辑，例如发送请求或导航到其他页面
        handleRoleIdClick(roleid);
    });
});

function handleRoleIdClick(roleid) {
    // 这里添加你的逻辑
    // redirectToUrl(`/chat/${roleid}`)
    // 例如，可以发送 AJAX 请求或执行其他操作
}
function isnetwork() {
    if (!navigator.onLine) {
        return false;
    } else {
        return true;
    }
}
function blobToFile(blob, fileName) {
    // A File is just like a Blob, but with additional properties like name and lastModifiedDate
    return new File([blob], fileName, {
        type: blob.type,
        lastModified: Date.now()  // or you can set your own date
    });
}
function isMobileDevice() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}
//记住页面来源
const urls = [
    '/account',
    '/register',
    '/login',
    '/account/passwordless-login',
    '/account/email-verification',
    '/account/reset-password',
    '/connect-account',
];

const currentUrl = window.location.pathname;

const isMatchingUrl = urls.some(url => currentUrl.includes(url));

if (isMatchingUrl) {
} else if (location.href.indexOf(lang_path+'/account/profile/') > -1 && /^\d+$/.test(location.href.split(lang_path+'/account/profile/')[1])) {
} else {
    localStorage.setItem('source', location.href);
}
$('.moreMenuButton').on('click', function () {
    var $menu = $('.menu_more-content');
    if ($menu.css('display') === 'none') {
        // 如果元素隐藏，点击后显示
        // $menu.css('top',`calc(${$(this).offset().top}px - 7.625rem)`);
        $menu.css('bottom', `${$(window).height() - $(this).offset().top + 10}px`);
        $menu.show();
        $('.popTransparentMask').addClass('active');
        $('.moreMenuButton').addClass('active')
    }
});


$('.popTransparentMask').on('click', function () {
    $('.menu_more-content').hide();
    $('.moreMenuButton').removeClass('active');
    $('.popTransparentMask').removeClass('active');
});

$('.drawer-main-mask').on('click', function () {
    $(this).hide();
    $('html, body').removeClass('hide');
    $('.menuIcon').removeClass('icon-menu_close').addClass('icon-menu')
})
$('.drawer-main-box').on('click', function (e) {
    e.stopPropagation();
})

// 排序弹窗点击关闭
$('#showRencent').on('click', function () {
    $('#showRencent').hide();
})

// 性别筛选弹窗关闭
$('#showGender').on('click', function () {
    $('#showGender').hide();
})

// 首页点击排序
try {
    $('.recent').click(function () {
        var $recent = $('#showRencent');

        if ($recent.css('display') === 'none') {
            // 如果元素隐藏，点击后显示
            $recent.show();
            let isDomShow = $('.switchBoxfalse').length > 0 || $('.switchBoxtrue').length > 0
            // if($('.switchBoxfalse').length ||$('.switchBoxtrue').length  ){

            // }
            if($(window).width()>650){
                $('.recentListContent,.recentSearchContent').css({
                    'top': $('.classification .recent').offset().top + 55 - $(window).scrollTop(),
                    'left': $('.classification .recent').offset().left - (isDomShow ? 8 : 50)
                });
            }else{
                $('.recentListContent,.recentSearchContent').css({
                    'top': $('.classification .recent').offset().top + 35 - $(window).scrollTop(),
                    'left': $('.classification .recent').offset().left - (isDomShow ? 8 : 50)
                });
            }
            $('html').addClass('hide');
        }
    })
} catch (e) {
    console.log(e);
}

// 首页点击性别筛选
try {
    $('.genderAll').click(function () {
        var $genderAll = $('#showGender');
        if ($genderAll.css('display') === 'none') {
            $genderAll.show();
            if($(window).width()>650){
                $('.recentListContent').css({
                    'top': $('.classification .genderAll').offset().top + 55  - $(window).scrollTop(),
                    'left': $('.classification .genderAll').offset().left - 8
                });
            }else{
                $('.recentListContent').css({
                    'top': $('.classification .genderAll').offset().top + 35  - $(window).scrollTop(),
                    'left': $('.classification .genderAll').offset().left - 8
                });
            }
            $('.genderAllTransparentMask').addClass('active');
            $(this).addClass('active');
            $('html').addClass('hide');
        }
    })
} catch (e) {
    console.log(e)
}

function addTooltip() {
    if (isMobileDevice()) {
        // 如果是移动设备，不添加Tooltip
        return;
    }

    var itemDiv = $('.itemDiv');
    itemDiv.each((i, el) => {
        $(el).find('.desc').each(function () {
            // 检查是否已经有 Tooltipster 实例
            if ($(this).hasClass('tooltipstered')) return;
            if (!$(this).hasClass('notext')) {
                try {
                    $(this).tooltipster({
                        minWidth: 300,
                        maxWidth: 300,
                        trigger: 'hover',
                    });
                } catch (e) {
                    console.log(e);
                }
            }
        });
    });
}
//成功
function successPermanent(txet) {
    $('body>.successPermanent').remove();
    $('body>.errorPermanent').remove();
    $('body>.warningPermanent').remove();
    $('body').append('<div class="successPermanent"><img src="/images/toast/icon_su.svg" alt="Success">' + txet + '</div>');
    setTimeout(function () {
        $('body>.successPermanent').remove();
    }, 5000);
};
//失败
function errorPermanent(txet) {
    $('body>.successPermanent').remove();
    $('body>.errorPermanent').remove();
    $('body>.warningPermanent').remove();
    $('body').append('<div class="errorPermanent"><img src="/images/toast/icon_dialogue.svg" alt="Error">' + txet + '</div>');
    setTimeout(function () {
        $('body>.errorPermanent').remove();
    }, 5000);
};
//警告
function warningPermanent(txet) {
    $('body>.successPermanent').remove();
    $('body>.errorPermanent').remove();
    $('body>.warningPermanent').remove();
    $('body').append('<div class="warningPermanent"><img src="/images/toast/icon-warning.svg" alt="Error">' + txet + '</div>');
    setTimeout(function () {
        $('body>.warningPermanent').remove();
    }, 5000);
};

function success(text) {
    showToast('success', text, '/images/toast/icon_su.svg');
}

function error(text) {
    showToast('error', text, '/images/toast/icon_dialogue.svg');
}

function warning(text) {
    showToast('warning', text, '/images/toast/icon-warning.svg');
}

function showToast(type, text, icon, top) {
    var top_text;
    top ? top_text = top : type == 'success' || type == 'error' || type == 'warning' ? top_text = capitalizeFirstLetter(type) : top_text = type;
    var toast = $(
        '<div class="toast ' + type + '">' +
        '<img src="' + icon + '" alt="' + type + '">' +
        '<div class="right">' +
        '<div><p>' + top_text + '</p><p>' + text + '</p></div>' +
        '<i class="close" onclick="closeToast(this)"></i>' +
        '</div>' +
        '</div>'
    );

    $('body').append(toast);

    adjustToastPositions();

    setTimeout(function () {
        toast.fadeOut(function () {
            $(this).remove();
            adjustToastPositions();
        });
    }, 3000);
};
function closeToast(closeButton) {
    var toast = $(closeButton).closest('.toast');
    toast.fadeOut(function () {
        toast.remove();
        adjustToastPositions();
    });
}

function adjustToastPositions() {
    var topOffset = 85; // 初始偏移量
    $('.toast').each(function () {
        $(this).css('top', topOffset + 'px');
        topOffset += $(this).outerHeight() + 10; // 每个 toast 的高度加上间距
    });
}

function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

window.onload = function () {
    // 阻止双击放大
    var lastTouchEnd = 0;
    document.addEventListener('touchstart', function (event) {
        if (event.touches.length > 1) { event.preventDefault(); }
    });
    document.addEventListener('touchend', function (event) {
        var now = (new Date()).getTime();
        if (now - lastTouchEnd <= 300) { event.preventDefault(); }
        lastTouchEnd = now;
    }, false);
    // 阻止双指放大
    // document.addEventListener('gesturestart', function(event) {
    //   event.preventDefault();
    // });
}

function checkLoginStatus() {
    // 检查 cookie 中是否存在登录信息
    const user = cookie.getcookie('user');
    if (user) {
        updateLoginState(true);
    } else {
        updateLoginState(false);
    }
}

function switchBoxtrue() {
    $('.switchBoxfalse').hide();
    $('.switchBoxtrue').show();
}
function switchBoxfalse() {
    $('.switchBoxtrue').hide();
    $('.switchBoxfalse').show();
}

function escapeHtml(str) {
    const entityMap = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
        '\t': '&emsp;',
    };
    if (!str) return ''
    return str.replace(/[&<>"'\t]/g, function (char) {
        return entityMap[char] || char;
    }).replace(/\n/g, '<br>');
}
function manage(operation, data) {
    try {
        dataLayer.push({
            'event': 'dotting',
            'name': 'HeyReal',
            'operation': operation,
            'lable': String(data)
        });
    } catch (e) {
        console.log(e);
    }
};
//公共区域位置打点
$(document).click(function (e) {
    try {
        if (e.target.getAttribute('data-operation') || e.target.getAttribute('data-label')) {
            manage(e.target.getAttribute('data-operation'), e.target.getAttribute('data-label'))
        }
    } catch (e) { }
})
function reportPrice(operation, data) {
    try {
        dataLayer.push({
            event: operation,
            ecommerce: data
        })
    } catch (e) {
        console.log(e)
    }
}
function impactReportPrice(transactionId,currency,items) {
    ire('trackConversion', 53046, {
        orderId: transactionId,
        customProfileId: cookie.getcookie('murmur'),
        customerId: "",
        customerEmail: "",
        customerStatus: "",
        currencyCode: currency,
        orderPromoCode: "",
        items:items,
        // orderDiscount: 15.00,
        // items: [
        //           {
        //       subTotal: 28.00,
        //       category: "Product Category 1",
        //       sku: "sku-11111",
        //       quantity: 2,
        //           name: "Product Name 1"
        //           },
        //        ]
             },
             {
             verifySiteDefinitionMatch:true
             }
             );
}
function reportTransaction(transactionId, totalValue, taxValue, shipping, currency,items) {
    gtag('event', 'purchase', {
      'transaction_id': transactionId,
      'value': totalValue,
      'tax': taxValue,
      'shipping': shipping,
      'currency': currency,
      'items':items
    //   'items':[
    //     {
    //         'item_id':1,
    //         'item_name':6,
    //         'price':'0.3',
    //         'quantity':'2'
    //     }
    //   ]
    });
    // gtag("event", "purchase", {
    //     transaction_id: "T_0345655",
    //     // Sum of (price * quantity) for all items.
    //     value: 72.05,
    //     tax: 3.60,
    //     shipping: 5.99,
    //     currency: "USD",
    //     coupon: "SUMMER_SALE",
    //     items: [
    //         {
    //             item_id: "SKU_12345",
    //             item_name: "Stan and Friends Tee",
    //             affiliation: "Google Merchandise Store",
    //             coupon: "SUMMER_FUN",
    //             discount: 2.22,
    //             index: 0,
    //             item_brand: "Google",
    //             item_category: "Apparel",
    //             item_category2: "Adult",
    //             item_category3: "Shirts",
    //             item_category4: "Crew",
    //             item_category5: "Short sleeve",
    //             item_list_id: "related_products",
    //             item_list_name: "Related Products",
    //             item_variant: "green",
    //             location_id: "ChIJIQBpAG2ahYAR_6128GcTUEo",
    //             price: 10.01,
    //             quantity: 3
    //         },
    //         {
    //             item_id: "SKU_12346",
    //             item_name: "Google Grey Women's Tee",
    //             affiliation: "Google Merchandise Store",
    //             coupon: "SUMMER_FUN",
    //             discount: 3.33,
    //             index: 1,
    //             item_brand: "Google",
    //             item_category: "Apparel",
    //             item_category2: "Adult",
    //             item_category3: "Shirts",
    //             item_category4: "Crew",
    //             item_category5: "Short sleeve",
    //             item_list_id: "related_products",
    //             item_list_name: "Related Products",
    //             item_variant: "gray",
    //             location_id: "ChIJIQBpAG2ahYAR_6128GcTUEo",
    //             price: 21.01,
    //             promotion_id: "P_12345",
    //             promotion_name: "Summer Sale",
    //             quantity: 2
    //         }]
    // });
}
function generateRandomTransactionId() {
    const prefix = 'T_';
    const randomNumber = Math.floor(Math.random() * 100000); // 生成 0 到 99999 之间的随机整数
    return prefix + randomNumber.toString().padStart(5, '0'); // 确保数字部分是 5 位，前面补零
}


//特殊字符判断
function test_name(a) {
    // var _test = /[\p{L}\d_\s#,.!?\u3002|\uff1f|\uff01|\uff0c|\u3001|\uff1b|\uff1a|\u201c|\u201d|\u2018|\u2019|\uff08|\uff09|\u300a|\u300b|\u3008|\u3009|\u3010|\u3011|\u300e|\u300f|\u300c|\u300d|\ufe43|\ufe44|\u3014|\u3015|\u2026|\u2014|\uff5e|\ufe4f|\uffe5]+[\u0020-\u007F]+|[\u00A0-\uD7FF\uE000-\uFFFF]+/gu;
    var _test = /[p]/g;
    var str = a;
    var str1 = str.replace(_test, '');
    var flag = true;
    str1.length > 0 ? flag = true : flag = false;
    return flag
}

//复制
function copyToClipboard(text) {
    var textarea = document.createElement('textarea');
    textarea.style.position = 'fixed';
    textarea.style.opacity = 0;
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
};

// 识别字符串中的html标签和script脚本
function identifyHtmlAndScript(text) {
    // 匹配所有 HTML 标签
    const htmlTagPattern = /<[^>]+>/g;
    const allTags = text.match(htmlTagPattern) || [];

    // 匹配 <script> 标签及其内容
    const scriptTagPattern = /<script[^>]*>[\s\S]*?<\/script>/gi;
    const scriptTags = text.match(scriptTagPattern) || [];

    // 将 <script> 标签从原文本中移除
    const cleanText = text.replace(scriptTagPattern, '');

    // 匹配移除 <script> 标签后的 HTML 标签
    const updatedHtmlTags = cleanText.match(htmlTagPattern) || [];

    // 拼接字符串
    const htmlTagsString = updatedHtmlTags.join(' ');
    const scriptTagsString = scriptTags.join(' ');
    return {
        htmlTags: htmlTagsString,
        scriptTags: scriptTagsString
    };
}

/**
 * 展示积分弹窗，同步积分
 * @param {*} num 积分
 * @param {*} el 元素
 * @param {*} text 兑换后展示文字
 */
function synchronizedPoints(num, el, text) {
    $('.missionAccomplished p .num em').text(num);
    let tempnum = parseInt($('.source').text());
    $('.source').text(tempnum + num);
    $('.remain_source').text(tempnum + num);
    $('.missionAccomplishedMask').show();
    setTimeout(function () {
        $('.missionAccomplishedMask').hide();
    }, 2000)
    $('.missionAccomplishedMask .close').click(function () {
        $('.missionAccomplishedMask').hide();
    });
    $('.missionContent').length && el.indexOf('signIn')>=-1 && $(`.missionContent ${el}`).text(text).removeClass('allow').addClass('no');
    $('.missionContent').length && el.indexOf('signIn')==-1 && el.indexOf('chat')==-1 && $(`.missionContent ${el}`).parent().parent().addClass('mission_toggled');
    $('.missionContent').length && el.indexOf('signIn')==-1 && el.indexOf('chat')==-1 && $(`.missionContent ${el}`).parent().parent().addClass('fit');
    getAjax(_url.getRedDot, {
    }).then(res => {
        if (res.code == 200) {
            $('.missionContent .social_num').text(res.data.social_num)
            if(res.data.social_num==6){
                $('.missionContent .SocialContent').addClass('fit').addClass('mission_toggled');
            }
            if (res.data && res.data.red_dot != 1) {
                $('.BonusMenu .icon-menu_bonus').removeClass('active');
            }
            if (res.data.message_red != 1 && res.data.red_dot != 1) {
                $('.navigation .leftNavigation .menuIcon').removeClass('active');
            }
            if(res.data.Mission_red == 1)$('.mission span').addClass('active');
            if(res.data.Mission_red == 0)$('.mission span').removeClass('active');
            if(res.data.Achievement_red == 1)$('.achievement span').addClass('active');
            if(res.data.Achievement_red == 0)$('.achievement span').removeClass('active');
        }
    })
};
// 上报ga公共方法
function updatePayMoneyGA(){
    getAjax('/api/gaPayMoneyUpload').then(res => {
        if (res.code == 200) {
            let items = [
                {
                    item_id: res.data.payOrderId,
                    item_name: res.data.name,
                    price: res.data.amount,
                    quantity: 1
                }
            ]
            let impactItems = [
                {
                    subTotal: res.data.amount,
                    category: res.data.name,
                    sku:res.data.payOrderId,
                    quantity: 1,
                    name: res.data.name
                },
            ];
            impactReportPrice(res.data.mchOrderNo,res.data.currency,impactItems)
            // showToast(i18n[lang].public_showToast_Success, i18n[lang].public_showToast_1, '/images/toast/icon_su.svg');
            reportTransaction(res.data.mchOrderNo, res.data.amount, '0', '0', res.data.currency, items)

        }
    })
};
// 上报Impact注册公共方法
function updateImpactRegister(){
    getAjax('/api/googleReport').then(res => {
        if (res.code == 200) {
            ire('trackConversion', 53045, {
                orderId: res.data.uid,
                customProfileId: murmur,
                customerId: res.data.uid,
                customerEmail: res.data.email,
                customerStatus: "new"
            },
                {
                    verifySiteDefinitionMatch: true
                }
            );

        }
    })
};
// dark-theme 
$('.navigation .header_select').on('click',function(e){
    e.stopPropagation();
    $(this).toggleClass('active');
    $('.language_select').removeClass('active');
    $('.menuIcon').removeClass('icon-menu_close').addClass('icon-menu');
    $('.drawer-main-mask').hide();
    $('html,body').removeClass('hide');
});
$(document).on('click',function(e){
    $('.navigation .header_select').removeClass('active');
});
$('.header_select_item').on('click',function(e){
    e.stopPropagation();
    $('.menuIcon').removeClass('icon-menu_close').addClass('icon-menu');
    $('.drawer-main-mask').hide();
    $('html,body').removeClass('hide');
    $(this).addClass('active').siblings().removeClass('active');
    $('.header_select').removeClass('active');
    //system-theme
    if($(this).index() == 2){
        cookie.setcookie('theme','system-theme',90);
        $('.layout-header,html').removeClass('dark-theme').removeClass('system-theme').removeClass('light-theme').addClass(system_theme).addClass('system-theme');
        $('.theme-item').each(function(index,item){
            var _src = $(item).attr('src').replace('/dark-theme','');
            if(system_theme == 'light-theme'){
                $(item).attr('src',_src.replace('/dark-theme',''))
                $('#loadBox')&&$('#loadBox').css('background','#f5f6f9');
                $('.result_info')&&$('.result_info').css('color','#555');
            }else if(system_theme == 'dark-theme'){
                $(item).attr('src',_src.replace('/images','/images/dark-theme'))
                $('#loadBox')&&$('#loadBox').css('background','#222');
                $('.result_info')&&$('.result_info').css('color','#fff');
            }
        })
        $('#loadBox')&&$('#loadBox').css('background','#f5f6f9');
        $('.result_info')&&$('.result_info').css('color','#555');
    }else{
        cookie.setcookie('theme',$(this).attr('attr-theme'),90);
        $('.layout-header,html').removeClass('dark-theme').removeClass('system-theme').removeClass('light-theme').addClass($(this).attr('attr-theme'));
        $('.theme-item').each(function(index,item){
            var _src = $(item).attr('src').replace('/dark-theme','');
            if($('html').attr('class').indexOf('light-theme')>-1){
                $(item).attr('src',_src.replace('/dark-theme',''))
                $('#loadBox')&&$('#loadBox').css('background','#f5f6f9');
                $('.result_info')&&$('.result_info').css('color','#555');
            }else if($('html').attr('class').indexOf('dark-theme')>-1){
                $(item).attr('src',_src.replace('/images','/images/dark-theme'))
                $('#loadBox')&&$('#loadBox').css('background','#222');
                $('.result_info')&&$('.result_info').css('color','#fff');
            }
        })
    }
});
if(!cookie.getcookie('theme')){
    cookie.setcookie('theme', 'light-theme', 90);
}else{
    var _theme = cookie.getcookie('theme');
    if(_theme == 'system-theme'){
        $('.header_select_item').length&&$('.header_select_item').eq(2).addClass('active').siblings().removeClass('active');
        $('.layout-header,html').removeClass('dark-theme').removeClass('system-theme').removeClass('light-theme').addClass(system_theme).addClass('system-theme');
        $('.theme-item').each(function(index,item){
            var _src = $(item).attr('src').replace('/dark-theme','');
            if(system_theme == 'light-theme'){
                $(item).attr('src',_src.replace('/dark-theme',''))
                $('#loadBox')&&$('#loadBox').css('background','#f5f6f9');
                $('.result_info')&&$('.result_info').css('color','#555');
            }else if(system_theme == 'dark-theme'){
                $(item).attr('src',_src.replace('/images','/images/dark-theme'))
                $('#loadBox')&&$('#loadBox').css('background','#222');
                $('.result_info')&&$('.result_info').css('color','#fff');
            }
        })
        $('#loadBox')&&$('#loadBox').css('background','#f5f6f9');
        $('.result_info')&&$('.result_info').css('color','#555');
    }else{
        if(_theme == 'light-theme'){
            $('.layout-header,html').removeClass('dark-theme').removeClass('system-theme').addClass('light-theme');
            $('.theme-item').each(function(index,item){
                var _src = $(item).attr('src').replace('/dark-theme','');
                if($('html').attr('class').indexOf('light-theme')>-1){
                    $(item).attr('src',_src.replace('/dark-theme',''))
                    $('#loadBox')&&$('#loadBox').css('background','#f5f6f9');
                    $('.result_info')&&$('.result_info').css('color','#555');
                }else if($('html').attr('class').indexOf('dark-theme')>-1){
                    $(item).attr('src',_src.replace('/images','/images/dark-theme'))
                    $('#loadBox')&&$('#loadBox').css('background','#222');
                    $('.result_info')&&$('.result_info').css('color','#fff');
                }
            })
            $('.header_select_item').length&&$('.header_select_item').eq(1).addClass('active').siblings().removeClass('active');
        }else if(_theme == 'dark-theme'){
            $('.layout-header,html').removeClass('light-theme').removeClass('system-theme').addClass('dark-theme');
            $('.theme-item').each(function(index,item){
                var _src = $(item).attr('src').replace('/dark-theme','');
                if($('html').attr('class').indexOf('light-theme')>-1){
                    $(item).attr('src',_src.replace('/dark-theme',''))
                    $('#loadBox')&&$('#loadBox').css('background','#f5f6f9');
                    $('.result_info')&&$('.result_info').css('color','#555');
                }else if($('html').attr('class').indexOf('dark-theme')>-1){
                    $(item).attr('src',_src.replace('/images','/images/dark-theme'))
                    $('#loadBox')&&$('#loadBox').css('background','#222');
                    $('.result_info')&&$('.result_info').css('color','#fff');
                }
            })
            $('.header_select_item').length&&$('.header_select_item').eq(0).addClass('active').siblings().removeClass('active');
        }
    }
}
const handleThemeChange = (event) => {
    var _theme = cookie.getcookie('theme');
    if (event.matches) {
        system_theme = 'dark-theme';
        if(_theme == 'system-theme'){
            $('.header_select_item').length&&$('.header_select_item').eq(2).addClass('active').siblings().removeClass('active');
            $('.layout-header,html').removeClass('dark-theme').removeClass('system-theme').removeClass('light-theme').addClass(system_theme).addClass('system-theme');
            $('.theme-item').each(function(index,item){
                var _src = $(item).attr('src').replace('/dark-theme','');
                if(system_theme == 'light-theme'){
                    $(item).attr('src',_src.replace('/dark-theme',''))
                    $('#loadBox')&&$('#loadBox').css('background','#f5f6f9');
                    $('.result_info')&&$('.result_info').css('color','#555');
                }else if(system_theme == 'dark-theme'){
                    $(item).attr('src',_src.replace('/images','/images/dark-theme'))
                    $('#loadBox')&&$('#loadBox').css('background','#222');
                    $('.result_info')&&$('.result_info').css('color','#fff');
                }
            })
            $('#loadBox')&&$('#loadBox').css('background','#f5f6f9');
            $('.result_info')&&$('.result_info').css('color','#555');
        }else{
        }
    } else {
        system_theme = 'light-theme';
        if(_theme == 'system-theme'){
            $('.header_select_item').length&&$('.header_select_item').eq(2).addClass('active').siblings().removeClass('active');
            $('.layout-header,html').removeClass('dark-theme').removeClass('system-theme').removeClass('light-theme').addClass(system_theme).addClass('system-theme');
            $('.theme-item').each(function(index,item){
                var _src = $(item).attr('src').replace('/dark-theme','');
                if(system_theme == 'light-theme'){
                    $(item).attr('src',_src.replace('/dark-theme',''))
                    $('#loadBox')&&$('#loadBox').css('background','#f5f6f9');
                    $('.result_info')&&$('.result_info').css('color','#555');
                }else if(system_theme == 'dark-theme'){
                    $(item).attr('src',_src.replace('/images','/images/dark-theme'))
                    $('#loadBox')&&$('#loadBox').css('background','#222');
                    $('.result_info')&&$('.result_info').css('color','#fff');
                }
            })
            $('#loadBox')&&$('#loadBox').css('background','#f5f6f9');
            $('.result_info')&&$('.result_info').css('color','#555');
        }else{
        }
    }
};
darkModeMediaQuery.addEventListener('change', handleThemeChange);

$('.chatMenu').on('click', function(e) {
    e.preventDefault();
    redirectToUrl(`https://heyreal.ai/chat/inbox`);
});